import * as React from 'react';
import { ELinkOpenMode, FavoritesAssignWidgetContainer as FavoritesAssignWidget } from '@cian/favorites-assign-widget';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from '../../actions/authentication';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux';
import { trackSaveToFolder } from './tracking';

export function FavoritesAssignWidgetContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [isMounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const handleWaitForLogin = React.useCallback(() => {
    dispatch(requestAuthentication({ alert: EAlertType.Favorites }));
  }, [dispatch]);

  if (!isMounted) {
    return null;
  }

  return (
    <FavoritesAssignWidget
      disableNotification
      isAuthenticated={isAuthenticated}
      linkOpenMode={ELinkOpenMode.Self}
      onSaveOffer={trackSaveToFolder}
      onWaitForLogin={handleWaitForLogin}
    />
  );
}
